import * as React from "react";
import { useState, useEffect } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import * as XLSX from "xlsx";
import {
  Button,
  Card,
  Form,
  Col,
  Row,
  Modal,
} from "react-bootstrap";
import { BsSearch, BsFileEarmarkExcel, BsFileEarmarkPdf } from "react-icons/bs";
import CatPermisos from "../../../Services/Catalogos/CatPermisos";
import { MsgInformativo } from "../../../Utils/Toast/msgInformativo";
import { DTOPermiso } from "../../../Componest/Catalogos/CatPermisos/DTO/DTOPermiso";
import CatEmpleados from '../../../Services/Catalogos/CatEmpleados';

export default function PermisoAccepted() {
  const [data, setData] = useState<DTOPermiso[]>([]);
  const [filteredData, setFilteredData] = useState<DTOPermiso[]>([]);
  const [inicio, setInicio] = useState(currentDate());
  const [fin, setFin] = useState(currentDate());
  const [filtro, setFiltro] = useState("");
  const [tipoReporte, setTipoReporte] = useState<string>("Todos");
  const [show, setShowMsg] = useState(false);
  const [msg, setMsg] = useState("");
  const [header, setHeader] = useState("");
  const msgColor = "primary";
  const [detalleTexto, setDetalleTexto] = useState("");
  const [showDetalle, setShowDetalle] = useState(false);

 
  function currentDate(): string {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  }

  

  const formatearFecha = (fecha: string) => {
  if (!fecha) return '';
  const date = new Date(fecha);
  const dia = date.getDate().toString().padStart(2, '0');
  const mes = (date.getMonth() + 1).toString().padStart(2, '0');
  const anio = date.getFullYear();
  return `${dia}/${mes}/${anio}`;
};
  const mostrarDetalle = (texto: string) => {
    setDetalleTexto(texto || "Sin información");
    setShowDetalle(true);
  };

  const generarReporte = () => {
    CatPermisos.getAllSoPermisos(inicio, fin, tipoReporte)
      .then((response) => {
        setData(response.data);
        setFilteredData(response.data);
        setHeader("Informativo");
        setMsg("Se encontró la siguiente información");
        setShowMsg(true);
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message || "Error al cargar los datos.";
        console.error("Error al obtener los datos:", error);
        setHeader("Error");
        setMsg(errorMessage);
        setShowMsg(true);
      });
  };

  const filtraReporte = (e: any) => {
    const searchText = e.target.value.toLowerCase();
    setFiltro(searchText);
    const filtered = data.filter((item) => {
      return (
        item.numEmpleado?.toString().toLowerCase().includes(searchText) ||
        item.nombreEmpleado?.toLowerCase().includes(searchText) ||
        item.fechaPermiso?.toString().toLowerCase().includes(searchText)
      );
    });
    setFilteredData(filtered);
  };

  const downloadExcel = () => {
  const filteredColumns = filteredData.map(({
    numEmpleado,
    nombreEmpleado,
    puestoEmpleado,
    fechaPermiso,
    motivo,
    observaciones,
    estado,
    esDiaCompleto,
    horaInicio,
    horaFin,
    permisoConSueldo,
    fechaAceptacionPermiso
  }) => ({
    numEmpleado,
    nombreEmpleado,
    puestoEmpleado,
    fechaPermiso: fechaPermiso ? new Date(fechaPermiso).toLocaleDateString() : '',
    motivo,
    horario: esDiaCompleto ? 'Día completo' : `${horaInicio} - ${horaFin}`,
    permisoConSueldo: permisoConSueldo ? 'Sí' : 'No',
    fechaAceptacionPermiso: fechaAceptacionPermiso ? new Date(fechaAceptacionPermiso).toLocaleDateString() : '',
    observaciones,
    estado
  }));

  exportExcel(filteredColumns, "ReportePermisos");
};


  const exportExcel = (jsonData: any[], fileName: string) => {
  const Heading = [[
    "No.Empleado",
    "Nombre",
    "Puesto",
    "Fecha Permiso",
    "Motivo",
    "Horario",
    "Permiso con Sueldo",
    "Fecha Aceptación",
    "Observaciones",
    "Estado"
  ]];

  const wb = XLSX.utils.book_new();
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
  XLSX.utils.sheet_add_aoa(ws, Heading);
  XLSX.utils.sheet_add_json(ws, jsonData, { origin: "A2", skipHeader: true });
  XLSX.utils.book_append_sheet(wb, ws, "Permisos");
  XLSX.writeFile(wb, `${fileName}.xlsx`);
};


  const columns: TableColumn<DTOPermiso>[] = [
    { name: "Empleado", selector: row => row.nombreEmpleado, sortable: true },
    { name: "NumEmpleado", selector: row => row.numEmpleado, sortable: true },
    { name: "Puesto", selector: row => row.puestoEmpleado, sortable: true },
    // { name: "Fecha Permiso", selector: row => formatearFecha(row.fechaPermiso), sortable: true },
    {name: "Fecha Permiso", selector: row => row.fechaPermiso ? new Date(row.fechaPermiso).toLocaleDateString() : '', sortable: true },
    { name: "Motivo", selector: row => row.motivo, sortable: true },
    {
  name: 'Horario',
  selector: row => row.esDiaCompleto 
    ? 'Día completo' 
    : `${row.horaInicio} - ${row.horaFin}`,
  sortable: true
}, 

    { name: "Estado", selector: row => row.estado, sortable: true },
    {name: 'Permiso con Sueldo', selector: row => row.permisoConSueldo ? 'Sí' : 'No', sortable: true },
    
    { name: "Fecha Aceptación", selector: row => row.fechaAceptacionPermiso ? new Date(row.fechaAceptacionPermiso).toLocaleDateString() : '', sortable: true },
    { name: "Observaciones", selector: row => row.observaciones, sortable: true },
    {
      name: 'PDF',
      cell: (row: DTOPermiso) => (
        <Button
          variant="info"
          size="sm"
          onClick={() => generarCredencialPermiso(row)}
          disabled={row.estado !== 'Aceptado'}
          title={row.estado !== 'Aceptado' ? 'Solo disponible si el permiso está aceptado' : 'Generar PDF'}
        >
          <i className="fas fa-file-pdf me-1"></i> PDF
        </Button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    }
  ];








  const generarCredencialPermiso = async (row: DTOPermiso) => {
    const response = await CatEmpleados.GetSuperFirma(row.numEmpleado);
    const numSupervisor = response.data?.numSupervisor || null;
    const numRh = response.data?.numEmpleadoRH || null;
    const numEmpleado = response.data?.numEmpleado || null;
  
    let firmaEmpleado = '';
    let firmaSupervisor = '';
    let firmaRH = '';
  
    try {
      if (numEmpleado) {
        const res = await CatEmpleados.GetFotoFirma(numEmpleado, 'firma');
        firmaEmpleado = res || '';
      }
      if (numSupervisor) {
        const res = await CatEmpleados.GetFotoFirma(numSupervisor, 'firma');
        firmaSupervisor = res || '';
      }
      if (numRh) {
        const res = await CatEmpleados.GetFotoFirma(numRh, 'firma');
        firmaRH = res || '';
      }
    } catch (e) {
      console.error('Error al obtener firmas:', e);
    }
  
    const ventana = window.open('', '_blank');
    if (!ventana) {
      alert('Desactiva el bloqueador de ventanas emergentes.');
      return;
    }
  
  ventana.document.write(`
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Credencial de Permiso</title>
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');
        body {
          font-family: 'Roboto', sans-serif;
          background-color: #f0f0f0;
          padding: 40px;
        }
        .card {
          width: 650px;
          margin: auto;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
          background-color: #ffffff;
        }
        .header {
          background: linear-gradient(to right, #0052cc, #007fff);
          color: white;
          padding: 30px;
          text-align: center;
          position: relative;
        }
        .header img {
          position: absolute;
          left: 20px;
          top: 20px;
          width: 60px;
        }
        .header h2 {
          margin: 0;
          font-size: 26px;
        }
        .content {
          padding: 30px;
          font-size: 18px;
        }
        .row {
          margin-bottom: 14px;
        }
        .row strong {
          display: inline-block;
          width: 160px;
        }
        .firmas {
          display: flex;
          justify-content: space-around;
          padding: 20px 30px 30px;
        }
        .firma {
          width: 100px;
          height: 60px;
          border: 1px dashed #999;
          padding: 4px;
          text-align: center;
        }
        .firma img {
          max-width: 100%;
          max-height: 100%;
        }
        .footer {
          background-color: #f9f9f9;
          text-align: center;
          padding: 15px;
          font-size: 14px;
          color: #666;
        }
      </style>
    </head>
    <body>
      <div class="card">
        <div class="header">
          <img src="GEMCO.png" alt="Logo" />
          <h2>Credencial de Permiso</h2>
        </div>
        <div class="content">
        
          <div class="row"><strong>Empleado:</strong> ${row.nombreEmpleado}</div>
          <div class="row"><strong>No. Empleado:</strong> ${row.numEmpleado}</div>
          <div class="row"><strong>Puesto:</strong> ${row.puestoEmpleado}</div>
          <div class="row"><strong>Fecha:</strong> ${formatearFecha(row.fechaPermiso)}</div>
          <div class="row"><strong>Motivo:</strong> ${row.motivo}</div>
          <div class="row"><strong>Horario:</strong> ${row.esDiaCompleto ? 'Día Completo' : `${row.horaInicio} - ${row.horaFin}`}</div>
          
          <div class="row"><strong>Observaciones:</strong> ${row.observaciones || 'N/A'}</div>
          <div class="row"><strong>Permiso con Sueldo:</strong> ${row.permisoConSueldo ? 'Sí' : 'No'}</div>
           <div class="row"><strong>Estado:</strong> ${row.estado}</div>
         
        </div>
        <div class="firmas">
          <div class="firma"><img src="${firmaEmpleado}" alt="Firma Empleado" /></div>
          <div class="firma"><img src="${firmaSupervisor}" alt="Firma Supervisor" /></div>
          <div class="firma"><img src="${firmaRH}" alt="Firma RH" /></div>
        </div>
        <div class="footer">
          GEMCO | Nuevo Laredo, Tamps. <br />
          www.gemcousa.com
        </div>
      </div>
      <script>setTimeout(() => { window.print(); window.close(); }, 600);</script>
    </body>
    </html>
  `);
  
    ventana.document.close();
  };
  
  
 
  

  const conditionalRowStyles = [
    {
      when: (row: DTOPermiso) => row.estado === 'Aceptado',
      style: {
        backgroundColor: '#d4edda', // verde claro de fondo fila
        color: '#155724',
        cursor: 'pointer',
      },
    },
    
    {
      when: (row: DTOPermiso) => row.estado === 'Pendiente'  ,
      style: {
        backgroundColor: '#f8d7da', // rojo claro
        color: '#721c24',
        cursor: 'pointer',
      },
    },
  ];





  
  return (
    <div className="mt-2">
      <Card.Body>
        <Form>
          <Row className="align-items-center">
            <Col xs={2}>
              <Form.Label>Desde</Form.Label>
              <Form.Control type="date" value={inicio} onChange={(e) => setInicio(e.target.value)} size="sm" />
            </Col>
            <Col xs={2}>
              <Form.Label>Hasta</Form.Label>
              <Form.Control type="date" value={fin} onChange={(e) => setFin(e.target.value)} size="sm" />
            </Col>
            <Col xs={2}>
              <Form.Label>Search</Form.Label>
              <Form.Control type="text" size="sm" placeholder="Buscar..." onChange={filtraReporte} />
            </Col>
            <Col xs={2}>
              <Form.Label>Tipo</Form.Label>
              <Form.Select
                size="sm"
                value={tipoReporte}
                onChange={(e) => setTipoReporte(e.target.value)}
              >
                <option value="Todos">Todos</option>
                <option value="Aceptado">Aceptados</option>
                <option value="Pendiente">Pendientes</option>
              </Form.Select>
            </Col>
            <Col xs={2}>
              <Button variant="primary" onClick={generarReporte}>
                <BsSearch /> Buscar
              </Button>
            </Col>
            <Col xs={2}>
              <Button variant="success" onClick={downloadExcel}>
                <BsFileEarmarkExcel /> Excel
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>

      <Card className="mt-3">
        <Card.Body>
          <DataTable
            noHeader
            defaultSortAsc
            striped
            dense
            pagination
            highlightOnHover
            columns={columns}
            data={filteredData}
            conditionalRowStyles={conditionalRowStyles}
          />
        </Card.Body>
      </Card>

      <Modal show={showDetalle} onHide={() => setShowDetalle(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Detalle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ whiteSpace: "pre-wrap" }}>{detalleTexto}</p>
        </Modal.Body>
      </Modal>

      <MsgInformativo
        show={show}
        msg={msg}
        header={header}
        msgColor={msgColor}
        closeToast={() => setShowMsg(false)}
      />
    </div>
  );
}
